import urlParse from 'url-parse';

import runtime from './runtime';

function isSlash(p) {
  return p === "/";
}

export function removeTrailingSlash(p) {
  return !isSlash(p) && p.endsWith('/') ? p.slice(0, -1) : p;
}

export function addLeadingSlash(p) {
  return p.startsWith('/') ? p : `/${p}`;
}

export function removeLeadingSlash(p) {
  return !isSlash(p) && p.startsWith('/') ? p.slice(1) : p
}

export function getRouteName(passedPath) {
  // const routeNameMap = runtime.get('routeNameMap')
  const pathname = passedPath || window.location.pathname
  // const p = removeTrailingSlash(pathname)

  // return routeNameMap[p] || pathname
  const config = getRouteConfig(pathname);
  return config ? config.name : pathname
}

export function getRouteConfig(passedPath) {
  const routeConfig = runtime.get('routeConfig')
  const pathname = passedPath || window.location.pathname
  const p = removeTrailingSlash(pathname)

  return routeConfig[p] || {};
}

export function getUrl() {
  return `${location.protocol}//${location.host}${location.pathname}`;
}
